import { FC } from "react";
import { Datagrid, List, TextField } from "react-admin";

import CustomPagination from "../../../../components/CustomPagination";
import EmptyDataText from "../../../../components/EmptyDataText";
import TimestampField from "../../../../components/TimestampField";
import useSharedStyles from "../../../../hooks/useSharedStyles";
import DeleteService from "../components/DeleteService";
import ServicePrice from "../components/ServicePrice";
import RefNumber from "./components/RefNumber";

const ServicesList: FC<any> = (props) => {
  const { styles } = useSharedStyles();

  return (
    <List
      {...props}
      sort={{ field: "createdAt", order: "desc" }}
      pagination={<CustomPagination />}
      bulkActionButtons={false}
      filters={false}
      exporter={false}
    >
      <Datagrid rowClick="edit" empty={<EmptyDataText message="No services yet!" />}>
        <RefNumber label="Ref Number" />
        <TextField source="name.en" label="Name (En)" sortable={false} cellClassName={styles.truncate2} />
        <TextField source="name.ar" label="Name (Ar)" sortable={false} cellClassName={styles.truncate2} />
        <TimestampField source="from" label="From" />
        <TimestampField source="to" label="To" />
        <TextField source="maxRequests" />
        <TextField source="requested" />
        <TextField source="status" />
        <ServicePrice label="Price" />
        <TimestampField source="createdAt" label="Created At" />
        <DeleteService />
      </Datagrid>
    </List>
  );
};

export default ServicesList;
